import axios from "axios";
import { decodeToken } from "./jwt";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://vrnlapi365.com:5038/";

export function mediaUrl(path) {
  if (!path) {
    return "";
  }
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const base = API_BASE_URL.endsWith("/") ? API_BASE_URL : `${API_BASE_URL}/`;
  return `${base}${String(path).replace(/^\//, "")}`;
}

function getHeaders() {
  return { "Content-Type": "application/json" };

  // return {
  //   "Content-Type": "multipart/form-data",
  //   'Accept': "application/json",
  //   'type': "formData",
  // };
}

const instance = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 1000,
  headers: getHeaders(),
});

instance.interceptors.request.use((config) => {
  if (
    [
      "/v1/user/easytogo-casino-amount-add",
      "/v1/wallet/doLoginAndLaunchEasyToCasino",
      "/v1/user/casino-amount-add",
      "/v1/wallet/doLoginAndLaunchGame",
      "/v1/wallet/login",
    ].includes(config?.url?.split("?")[0])
  ) {
    const loader = document.getElementById("loading");
    if (loader) loader.style.display = "flex";
  }
  const token = localStorage.getItem("token");
  if (!token || !decodeToken(token)) {
    if (token) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("userId");
    }
    return config;
  }
  config = {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` },
  };
  return config;
});

instance.interceptors.response.use(
  function (response) {
    if (document.getElementById("loading") !== null) {
      document.getElementById("loading").style.display = "none";
    }
    return response;
  },
  function (error) {
    const status = error.response?.status;
    if (document.getElementById("loading") !== null) {
      document.getElementById("loading").style.display = "none";
    }
    const requestUrl = `${error.config?.url || ""}`;
    const isAuthAttempt = requestUrl.includes("/v1/user/login") || requestUrl.includes("/v1/user/register");
    if ((status === 401 || status === 403) && !isAuthAttempt) {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("uniqueId");
      window.location.reload();
    }
    return Promise.reject(error);
  }
);

function toResponse(error) {
  if (error?.response) {
    return error.response;
  }
  return {
    status: error?.status || 0,
    data: { success: false, message: error?.message || "Request failed" },
  };
}

function apiGet(url, params = {}) {
  return instance.get(url, { params }).catch(toResponse);
}

function apiPost(url, body) {
  return instance.post(url, body).catch(toResponse);
}

function apiPut(url, body) {
  return instance.put(url, body).catch(toResponse);
}

function apiDelete(url) {
  return instance.delete(url).catch(toResponse);
}

export { getHeaders, apiGet, apiPost, apiPut, apiDelete };
